module.exports = __webpack_public_path__ + "static/green-port-seals-b916e87250443efc1a4e79420e081628.jpg";